import { render, staticRenderFns } from "./FestiusEmpresa.vue?vue&type=template&id=8c596080&scoped=true&"
import script from "./FestiusEmpresa.vue?vue&type=script&lang=js&"
export * from "./FestiusEmpresa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c596080",
  null
  
)

export default component.exports